import { createTheme } from "@mui/material/styles";
const theme = createTheme({
  palette: {
    mode: "light",

    primary: {
      main: "#FF8A00",
    },

    secondary: {
      main: "#3C4350",
    },
    warning: {
      main: "#ed6c02",
    },
    // success: {

    // },
    text: {
      primary: "#2c405a",
      secondary: "#657786",
    },
    actions: {},
    background: {
      default: "#F2F2F2",
      paper: "#ffffff",
    },
  },

  // Override custom
  components: {
    // MuiTypography: {
    //   styleOverrides: {
    //     root: {
    //       overflow: "hidden",
    //       textOverflow: "ellipsis",
    //       display: "-webkit-box",
    //       // Adjust the number of lines based on your requirement
    //       WebkitLineClamp: 3, // Example: Show up to 3 lines before truncating
    //       WebkitBoxOrient: "vertical",
    //       // textWrap: "wrap",
    //       // textAlign: "left",
    //     },
    //   },
    // },
    // MuiButton: {
    //   styleOverrides: {
    //     root: {
    //       width: "150px",
    //       height: "48px !important",
    //       fontSize: "1rem",
    //       textTransform: "none",
    //       fontWeight: 400,
    //       boxShadow: "none",
    //     },
    //   },
    // },


  },
});

export default theme;
